export function getParams(state) {
    return state.params
}

export function categoriesList(state) {
    return state.categoriesList
}


// WEBPACK FOOTER //
// ./src/modules/categories/getters.js